import { connect } from "react-redux";
import { ApplicationState } from "store";
import {
    actionCreators as uiActionCreators,
    getDomain,
    getRubberbandItem,
    getShowUserMenu,
    getSpiralItem,
} from "ui/store";
import {
    getBackCoverImage,
    getCoverImage,
    getCustomBackImage,
    getCustomCoverImage,
} from "burde-api-content/store";
import { actionCreators, getCalendar } from "page/calendar/store";
import {
    actionCreators as userActionCreators,
    getIsAuthenticated,
} from "user/store";
import UserNavigation from "./user-navigation";
import { getResource } from "resource/store";

const mapStateToProps = (state: ApplicationState) => ({
    UserNav_User: getResource(state, { key: "UserNav_User" }),
    UserNav_Admin: getResource(state, { key: "UserNav_Admin" }),
    UserNav_Orderhistory: getResource(state, { key: "UserNav_Orderhistory" }),
    UserNav_Logout: getResource(state, { key: "UserNav_Logout" }),
    UserNav_Design_Header: getResource(state, { key: "UserNav_Design_Header" }),
    UserNav_Design_Checkbox_Theme: getResource(state, {
        key: "UserNav_Design_Checkbox_Theme",
    }),
    UserNav_Design_Name_Placeholder: getResource(state, {
        key: "UserNav_Design_Name_Placeholder",
    }),
    UserNav_Design_Button_SaveAsTheme: getResource(state, {
        key: "UserNav_Design_Button_SaveAsTheme",
    }),
    UserNav_Design_Button_Save: getResource(state, {
        key: "UserNav_Design_Button_Save",
    }),
    UserNav_Design_List_Header: getResource(state, {
        key: "UserNav_Design_List_Header",
    }),
    Calendar_Size: getResource(state, {
        key: "Calendar_Size",
    }),
    isAuthenticated: getIsAuthenticated(state),
    showUserMenu: getShowUserMenu(state),
    calendar: getCalendar(state),
    coverImage: getCoverImage(state),
    backCoverImage: getBackCoverImage(state),
    customCoverImage: getCustomCoverImage(state),
    customBackImage: getCustomBackImage(state),
    spiralItem: getSpiralItem(state),
    rubberbandItem: getRubberbandItem(state),
    domain: getDomain(state),
});

const mapDispatchToProps = {
    ...actionCreators,
    ...uiActionCreators,
    ...userActionCreators,
};

export default connect(mapStateToProps, mapDispatchToProps)(UserNavigation);
